// extracted by mini-css-extract-plugin
module.exports = {"card":"SignIn_card__2TLVH","logo":"SignIn_logo__3SVCx","form":"SignIn_form__32lS4","error":"SignIn_error__3cv0F","footerLinks":"SignIn_footerLinks__1BQld"};